/* tslint:disable */
import {
  App
} from '../index';

declare var Object: any;
export interface ProfileInterface {
  name: string;
  lastupdatedby?: string;
  createdby?: string;
  customappsettings?: Array<any>;
  menusettings?: Array<any>;
  adminpermissions?: Array<any>;
  generalpermissions?: Array<any>;
  entitypermissions?: Array<any>;
  id?: any;
  appId?: any;
  createdAt: Date;
  updatedAt: Date;
  app?: App;
}

export class Profile implements ProfileInterface {
  name: string;
  lastupdatedby: string;
  createdby: string;
  customappsettings: Array<any>;
  menusettings: Array<any>;
  adminpermissions: Array<any>;
  generalpermissions: Array<any>;
  entitypermissions: Array<any>;
  id: any;
  appId: any;
  createdAt: Date;
  updatedAt: Date;
  app: App;
  constructor(data?: ProfileInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Profile`.
   */
  public static getModelName() {
    return "Profile";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Profile for dynamic purposes.
  **/
  public static factory(data: ProfileInterface): Profile{
    return new Profile(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Profile',
      plural: 'profiles',
      properties: {
        name: {
          name: 'name',
          type: 'string'
        },
        lastupdatedby: {
          name: 'lastupdatedby',
          type: 'string',
          default: 'system'
        },
        createdby: {
          name: 'createdby',
          type: 'string',
          default: 'system'
        },
        customappsettings: {
          name: 'customappsettings',
          type: 'Array&lt;any&gt;'
        },
        menusettings: {
          name: 'menusettings',
          type: 'Array&lt;any&gt;'
        },
        adminpermissions: {
          name: 'adminpermissions',
          type: 'Array&lt;any&gt;'
        },
        generalpermissions: {
          name: 'generalpermissions',
          type: 'Array&lt;any&gt;'
        },
        entitypermissions: {
          name: 'entitypermissions',
          type: 'Array&lt;any&gt;'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        appId: {
          name: 'appId',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        app: {
          name: 'app',
          type: 'App',
          model: 'App'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Profile.ts